/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cl_Affects_TemplatesInputs */

const en_cl_affects_templates = /** @type {(inputs: Cl_Affects_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which description template new items start from.`)
};

const de_cl_affects_templates = /** @type {(inputs: Cl_Affects_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit welcher Beschreibungsvorlage neue Elemente starten.`)
};

/**
* | output |
* | --- |
* | "Which description template new items start from." |
*
* @param {Cl_Affects_TemplatesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cl_affects_templates = /** @type {((inputs?: Cl_Affects_TemplatesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cl_Affects_TemplatesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cl_affects_templates(inputs)
	return en_cl_affects_templates(inputs)
});